import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleRight, FaUserFriends, FaWallet } from "react-icons/fa";
import { FiLogOut, FiSettings } from "react-icons/fi";
import { MdDashboard, MdDeleteSweep, MdOutlineRequestQuote } from "react-icons/md";
import { HiOutlineMenu, HiMenu } from "react-icons/hi";

const SideNavBar = ({
  setOpenPage,
  isCollapsed,
  toggleSidebar,
  setIsCollapsed,
}) => {
  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const menuSectionRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const UserName = localStorage.getItem("UserName");
  const UserAvatar = localStorage.getItem("UserAvatar");
  const userDepartment = localStorage.getItem("UserDepartment") || 1;

  useEffect(() => {
    const handleMouseEnter = () => {
      if (isCollapsed) {
        setIsHovered(true);
        setIsCollapsed(false);
      }
    };

    const handleMouseLeave = () => {
      if (isHovered) {
        setIsHovered(false);
        setIsCollapsed(true);
      }
    };

    const menuSection = menuSectionRef.current;
    if (menuSection) {
      menuSection.addEventListener("mouseenter", handleMouseEnter);
      menuSection.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (menuSection) {
        menuSection.removeEventListener("mouseenter", handleMouseEnter);
        menuSection.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [isCollapsed, isHovered, setIsCollapsed]);

  const handleLogout = () => {
    localStorage.removeItem("authToken"); 
    navigate("/login"); 
  };

  return (
    <div
      className={`fixed top-0 left-0 bg-gray-900 h-screen flex flex-col transition-all duration-300 ease-in-out z-50 ${
        isCollapsed && !isHovered ? "w-[3.6rem]" : "w-[13.9rem]"
      }`}
    >
      {/* Header */}
      <div
        className={`px-2 border-b py-3 border-gray-700 flex ${
          isCollapsed && !isHovered ? "justify-center" : "justify-between"
        } items-center`}
      >
        {(!isCollapsed || isHovered) && (
          <div className="flex items-center gap-4 overflow-hidden">
            <img
              src={UserAvatar || ""}
              className="w-9 h-9 rounded-full shrink-0"
              alt="Profile"
            />
            <p className="text-white whitespace-nowrap transition-all duration-300 ease-in-out">
              {UserName || "Soumitra Halder"}
            </p>
          </div>
        )}
        <button
          onClick={toggleSidebar}
          className="text-white p-2 rounded-md hover:bg-gray-700 transition-colors shrink-0"
        >
          {isCollapsed && !isHovered ? (
            <HiMenu className="text-2xl" />
          ) : (
            <HiOutlineMenu className="text-2xl" />
          )}
        </button>
      </div>

      
      <div
        ref={menuSectionRef}
        className={`flex flex-col p-2 text-white overflow-y-auto h-[83vh] [&::-webkit-scrollbar]:w-2
        [&::-webkit-scrollbar-track]:bg-gray-900
        [&::-webkit-scrollbar-thumb]:bg-gray-900
        dark:[&::-webkit-scrollbar-track]:bg-gray-900
        dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500`}
      >
        {/* Dashboard */}
        {userDepartment <= 3 && (
          <>
        <Link
          to="/dashboard"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "dashboard" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Dashboard" : ""}
          onClick={() => {
            setActive("dashboard");
            setOpenPage("dashboard");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <MdDashboard className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Dashboard</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        {/* User Details */}
        <Link
          to="/user-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "user details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "user details" : ""}
          onClick={() => {
            setActive("user details");
            setOpenPage("user details");
            
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FaUserFriends className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">User Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        </>
        )}
        {/* Task Details */}
        <Link
          to="/task-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "Task Details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Task Details" : ""}
          onClick={() => {
            setActive("Task Details");
            setOpenPage("Task Details");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FaWallet className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Task Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        {/* Task Add */}
        <Link
          to="/task-add"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "task add" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Task Add" : ""}
          onClick={() => {
            setActive("task add");
            setOpenPage("task add");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <MdOutlineRequestQuote className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Task Add</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        
        <Link
          to="/completed-task"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "Completed Task" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Completed Task" : ""}
          onClick={() => {
            setActive("Completed Task");
            setOpenPage("Completed Task");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FaWallet className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Completed Task</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        {userDepartment <= 3 && (
          <>
        {/* Department Details */}
         <Link
          to="/department-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "department details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "department details" : ""}
          onClick={() => {
            setActive("department details");
            setOpenPage("department details");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Department Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        {/* Role Details */}
        <Link
          to="/role-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "role details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "role details" : ""}
          onClick={() => {
            setActive("role details");
            setOpenPage("role details");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Role Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        {/* Designation Details */}
        {/* <Link
          to="/designation-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "designation details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "designation details" : ""}
          onClick={() => {
            setActive("designation details");
            setOpenPage("designation details");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Designation Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link> */}
        {/* LogIn Details */}
        <Link
          to="/login-logs"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "Login Logs Details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Login Logs Details" : ""}
          onClick={() => {
            setActive("Login Logs Details");
            setOpenPage("Login Logs Details");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Login Logs Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        <Link
          to="/app-version"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "App Version" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "App Version" : ""}
          onClick={() => {
            setActive("App Version");
            setOpenPage("App Version");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">App Version</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
      </>
        )}
        {/* <Link
          to="/delete-request"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "Delete Request" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Delete Request" : ""}
          onClick={() => {
            setActive("Delete Request");
            setOpenPage("Delete Request");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Delete Request</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link> */}

        
        
      </div>

      
      <div className="mt-auto p-4 border-t border-gray-700">
        <div
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : ""
          } items-center gap-3 text-white cursor-pointer hover:text-gray-300 transition-colors`}
          title={isCollapsed && !isHovered ? "Logout" : ""}
          onClick={handleLogout}
        >
          <FiLogOut className="shrink-0" />
          {(!isCollapsed || isHovered) && (
            <p className="whitespace-nowrap transition-all duration-300 ease-in-out">
              Logout
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideNavBar;
